import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';

export interface ErroNbs {
  id: number;
  dataOcorrencia: string;
  mensagem: string;
  classe: string;
  metodo: string;
  linha: number;
  arquivo: string;
  path: string;
  httpMethod: string;
  stacktrace: string;
  payload: string;
  params: string;
}

export interface ClasseErrosIgnorados {
  idIgnorado: number;
  classe: string;
  metodo: string;
  mensagens: string[];
  dataIgnorado: string;
}

@Injectable({
  providedIn: 'root'
})
export class GerenciarErrosService {

  private baseUrlService: string;

  constructor(private httpClient: HttpClient) {
    this.baseUrlService = environment.URL_API;
  }

  private getHttpOptions() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': JSON.parse(sessionStorage.getItem('currentUser')).token
      })
    };
  }

  /**
   * Lista todos os erros registrados
   */
  public listarErros(): Observable<ErroNbs[]> {
    return this.httpClient.get<ErroNbs[]>(`${this.baseUrlService}/erros`, this.getHttpOptions());
  }


  public deletarErro(id: number): Observable<any> {
    return this.httpClient.delete<any>(`${this.baseUrlService}/erros/${id}`, this.getHttpOptions());
  }


  public listarErrosIgnorados(): Observable<ClasseErrosIgnorados[]> {
    return this.httpClient.get<ClasseErrosIgnorados[]>(`${this.baseUrlService}/erros/ignorados`, this.getHttpOptions());
  }

  public ignorarClassePorErroId(idErro: number): Observable<any> {
    return this.httpClient.post<any>(`${this.baseUrlService}/erros/${idErro}/ignorar`, {}, this.getHttpOptions());
  }

  public removerClasseIgnorada(idIgnorado: number): Observable<any> {
    return this.httpClient.delete<any>(`${this.baseUrlService}/erros/ignorados/${idIgnorado}`, this.getHttpOptions());
  }
}

